import { createFileRoute } from '@tanstack/react-router'

import { CONFIG_SECTIONS } from '@/config/configuration/sections'
import { ConfigurationPage } from '@/components/configuration/configuration-page'

interface ConfigurationSearch {
  section?: string
  agent?: string
}

export const Route = createFileRoute('/configuration')({
  validateSearch: (search: Record<string, unknown>): ConfigurationSearch => ({
    section:
      typeof search.section === 'string' &&
      CONFIG_SECTIONS.some((section) => section.id === search.section)
        ? search.section
        : undefined,
    agent: typeof search.agent === 'string' ? search.agent : undefined,
  }),
  component: ConfigurationPage,
})
